import React from 'react'

const { AdminBlock } = global.rootRequire('components/shares/rxTemplates')
const RxCrud = global.rootRequire('components/shares/rxCrud').default

// Parse a raw "Cookie:" header string into a { name: value } map. Splits on the
// first "=" of each "; "-separated part so values containing "=" stay intact.
const parseCookieString = (str) => {
  const map = {}
  String(str || '').split(';').forEach(part => {
    const idx = part.indexOf('=')
    if (idx === -1) return
    const key = part.slice(0, idx).trim()
    if (key) map[key] = part.slice(idx + 1).trim()
  })
  return map
}

// Paste a full cookie string -> auto-fill the 3 required fields. Exact key match
// so __Secure-1PSID is not confused with __Secure-1PSIDTS / -1PSIDRTS / -1PSIDCC.
const onImportCookie = (inthis, e) => {
  const raw = e.target.value
  const map = parseCookieString(raw)
  const editingData = inthis.state.editingData
  editingData.cookie_import = raw
  if (map['GA_XSRF_TOKEN'] !== undefined) { editingData.xsrf_token = map['GA_XSRF_TOKEN'] }
  if (map['__Secure-1PSID'] !== undefined) { editingData.secure_psid = map['__Secure-1PSID'] }
  if (map['__Secure-1PSIDTS'] !== undefined) { editingData.secure_psidts = map['__Secure-1PSIDTS'] }
  inthis.setState({ editingData: editingData })
}

export const renderTableHead = (context, vm) =>
  <tr>
    <th className={context.helpSortClass('name', ['rx-th-width-220'])} onClick={(e) => context.onClickSort(e, 'name')}>Name</th>
    <th className={context.helpSortClass('xsrf_token', ['rx-th-width-220'])} onClick={(e) => context.onClickSort(e, 'xsrf_token')}>GA_XSRF_TOKEN</th>
    <th className={context.helpSortClass('secure_psid', ['rx-th-width-220'])} onClick={(e) => context.onClickSort(e, 'secure_psid')}>__Secure-1PSID</th>
    <th className={context.helpSortClass('secure_psidts', ['rx-th-width-220'])} onClick={(e) => context.onClickSort(e, 'secure_psidts')}>__Secure-1PSIDTS</th>
    <th className={context.helpSortClass('created_at', ['rxwidth--120'])} onClick={(e) => context.onClickSort(e, 'created_at')}>Created at</th>
    <th className='rxwidth--100'>Action</th>
  </tr>

export const renderTableBody = (context, vm) => global.rxu.array(context.state.data).map(perdata =>
  <tr key={perdata._id}>
    <td className='betable__gamelink'>{perdata.name}</td>
    <td style={{ wordBreak: 'break-all' }}>{perdata.xsrf_token}</td>
    <td style={{ wordBreak: 'break-all' }}>{perdata.secure_psid}</td>
    <td style={{ wordBreak: 'break-all' }}>{perdata.secure_psidts}</td>
    <td><small>{global.rxu.date(perdata.created_at)}</small></td>
    {context.renderTableBodyBtns(context, perdata)}
  </tr>)

export const renderComponent = (vm) =>
  <AdminBlock name='GA Auth' desc='Cấu hình GA_XSRF_TOKEN, __Secure-1PSID và __Secure-1PSIDTS. Lần chạy authGA gần nhất sẽ lấy bản ghi mới nhất.'>
    <div className='rxcol-100'>
      <RxCrud
        onClickDataNew={vm.onClickDataNew}
        renderTableHead={vm.renderTableHead}
        renderTableBody={vm.renderTableBody}
        name='gaauth'
        api='api_gaauth'
        form={[
          { type: 'devide' },
          { name: 'Import cookie', func: (inthis) => (<textarea tabIndex='1' rows='4' placeholder='Paste toàn bộ cookie ở đây, hệ thống tự tách GA_XSRF_TOKEN, __Secure-1PSID, __Secure-1PSIDTS' value={inthis.state.editingData.cookie_import || ''} onChange={(e) => onImportCookie(inthis, e)} className='fullwidth-input' style={{ wordBreak: 'break-all' }} />) },
          { type: 'devide' },
          { name: 'Name', func: (inthis) => (<input tabIndex='1' type='text' value={inthis.state.editingData.name} onChange={(e) => inthis.onBlurData(e, 'name')} className='fullwidth-input' />) },
          { type: 'devide' },
          { name: 'GA_XSRF_TOKEN', func: (inthis) => (<input tabIndex='1' type='text' value={inthis.state.editingData.xsrf_token} onChange={(e) => inthis.onBlurData(e, 'xsrf_token')} className='fullwidth-input' />) },
          { name: '__Secure-1PSID', func: (inthis) => (<input tabIndex='1' type='text' value={inthis.state.editingData.secure_psid} onChange={(e) => inthis.onBlurData(e, 'secure_psid')} className='fullwidth-input' />) },
          { name: '__Secure-1PSIDTS', func: (inthis) => (<input tabIndex='1' type='text' value={inthis.state.editingData.secure_psidts} onChange={(e) => inthis.onBlurData(e, 'secure_psidts')} className='fullwidth-input' />) }
        ]}
      />
    </div>
  </AdminBlock>
